import { render } from "./Customer.vue?vue&type=template&id=43ccdaf8&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=43ccdaf8&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=43ccdaf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ccdaf8"]])

export default __exports__